<li [class.active]="isActive"
    [pTooltip]="text"
    [tooltipDisabled]="!isReportGroup || text.length < 16"
    tooltipPosition="bottom">
  <i [class]="icon"></i>
  <span>{{ text }}</span>
</li>
